module.exports = __webpack_public_path__ + "img/mobile-white.2c824483.svg";